import React from "react";
import { Container, Row, Col } from "react-bootstrap";

const qualifications = [
  "IRATA Level 2 rope access qualification",
  "Practical work-at-height experience",
  "Safety-conscious cooperation on site",
  "Attention to agreed site procedures",
  "Experience in industrial, construction, and technical environments",
];

const QualificationsSafety = () => {
  return (
    <section id="qualifications" className="section-spacing safety-section text-white">
      <Container>
        <Row className="g-5 align-items-start">
          <Col lg={5}>
            <p className="section-kicker section-kicker-gold">Qualifications & Safety</p>
            <h2 className="section-title">Qualifications & Safety-Conscious Work</h2>
            <p className="lead safety-lead">
              SUPPoland is operated by an IRATA Level 2 rope access technician
              with practical experience in industrial, construction, and
              technical project environments across Europe.
            </p>
            <p className="mb-0">
              Work is approached with attention to agreed site procedures,
              responsible preparation, PPE condition, and disciplined cooperation
              with contractors, subcontractors, and project teams.
            </p>
          </Col>
          <Col lg={7}>
            <Row className="g-3 qualification-grid">
              {qualifications.map((item) => (
                <Col md={6} key={item}>
                  <div className="safety-item">{item}</div>
                </Col>
              ))}
              <Col md={12}>
                <div className="safety-item safety-item-highlight">
                  <h3 className="h5 fw-bold mb-2">Fall Protection PPE Inspection</h3>
                  <p className="mb-0">
                    SUPPoland is qualified to carry out periodic inspections,
                    including annual checks, of selected fall-protection PPE used
                    for work at height.
                  </p>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default QualificationsSafety;